var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconYoutube0137E15908(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_574)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5042 12.2913L11.6967 10.9813C11.4517 10.8675 11.2505 10.995 11.2505 11.2662V13.7338C11.2505 14.005 11.4517 14.1325 11.6967 14.0188L14.503 12.7087C14.7492 12.5938 14.7492 12.4063 14.5042 12.2913ZM12.5005 0.5C5.87299 0.5 0.500488 5.8725 0.500488 12.5C0.500488 19.1275 5.87299 24.5 12.5005 24.5C19.128 24.5 24.5005 19.1275 24.5005 12.5C24.5005 5.8725 19.128 0.5 12.5005 0.5ZM12.5005 17.375C6.35799 17.375 6.25049 16.8213 6.25049 12.5C6.25049 8.17875 6.35799 7.625 12.5005 7.625C18.643 7.625 18.7505 8.17875 18.7505 12.5C18.7505 16.8213 18.643 17.375 12.5005 17.375Z",
    fill: "#F1F6FA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_574"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconYoutube0137E15908);
export default __webpack_public_path__ + "static/media/icon_youtube_0137e15908.4493f687b4e046bb850e3a6d6b64d765.svg";
export { ForwardRef as ReactComponent };